import { areNumbersClose } from './areNumbersClose';
import { isNullOrUndefined } from './isNullOrUndefined';

export const annualHealthcareInflationRate = 0.054; // not available in state when needed in calcCarePhaseCosts so pulled out of Citations.tsx

export const isHealthcareInflationRateDefault = (
  healthCareInflationRate: number | null | undefined,
) => {
  if (isNullOrUndefined(healthCareInflationRate)) {
    return true;
  }
  return areNumbersClose(
    healthCareInflationRate,
    annualHealthcareInflationRate,
  );
};
